// Common language options with flag emojis
export const LANGUAGE_OPTIONS = [
  { value: "en", label: "🇺🇸 English", emoji: "🇺🇸" },
  { value: "nl", label: "🇳🇱 Dutch", emoji: "🇳🇱" },
  { value: "de", label: "🇩🇪 German", emoji: "🇩🇪" },
  { value: "fr", label: "🇫🇷 French", emoji: "🇫🇷" },
  { value: "es", label: "🇪🇸 Spanish", emoji: "🇪🇸" },
  { value: "it", label: "🇮🇹 Italian", emoji: "🇮🇹" },
  { value: "pt", label: "🇵🇹 Portuguese", emoji: "🇵🇹" },
  { value: "ru", label: "🇷🇺 Russian", emoji: "🇷🇺" },
  { value: "zh", label: "🇨🇳 Chinese", emoji: "🇨🇳" },
  { value: "ja", label: "🇯🇵 Japanese", emoji: "🇯🇵" },
  { value: "ko", label: "🇰🇷 Korean", emoji: "🇰🇷" },
  { value: "ar", label: "🇸🇦 Arabic", emoji: "🇸🇦" },
];

// Helper function to get language info
export const getLanguageInfo = (code: string) => {
  return (
    LANGUAGE_OPTIONS.find((opt) => opt.value === code) || {
      value: code,
      label: code.toUpperCase(),
      emoji: "🌐",
    }
  );
};

// Helper function to get just the language name without emoji
export const getLanguageName = (code: string) => {
  const info = getLanguageInfo(code);
  return info.label.replace(`${info.emoji} `, "");
};

// Helper function to format language display with emoji
export const formatLanguageDisplay = (code: string) => {
  const info = getLanguageInfo(code);
  return `${info.emoji} ${getLanguageName(code)}`;
};
